'use client';

import { Button, cn } from '@heroui/react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import AnimatedGridPattern from '@/components/ui/backgrounds/animated-grid-pattern';
import { APP_ROUTES } from '@/shared/constants/app-routes';
import { buildAppRoute } from '@/shared/functions/build-app-route';

export default function Unauthorized() {
	const pathName = usePathname();
	return (
		<main className="flex h-dvh w-full flex-col items-center justify-center gap-2">
			<AnimatedGridPattern
				numSquares={30}
				maxOpacity={0.1}
				duration={3}
				className={cn('mask-[radial-gradient(500px_circle_at_center,white,transparent)]', 'inset-0 -z-10')}
			/>
			<div className="flex flex-col items-center justify-center gap-8 p-4">
				<h1 className="text-5xl text-center font-bold select-none">Sem permissão para acessar essa página</h1>
				<div className="flex items-center gap-2">
					<Button
						as={Link}
						href={
							pathName.startsWith('/admin/')
								? buildAppRoute(APP_ROUTES.PRIVATE.ADMIN.HOME)
								: pathName.endsWith('/home')
									? buildAppRoute(APP_ROUTES.PUBLIC.LOGIN)
									: buildAppRoute(APP_ROUTES.PRIVATE.HOME)
						}
						className="font-medium"
						size="lg"
						variant="shadow"
						color="success"
					>
						Início
					</Button>
				</div>
			</div>
		</main>
	);
}
